import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bool } from 'prop-types';
import { finances, slaves } from '../../services/ApiService';
import { iFMessage, FMessage } from '../../hoc/IntlComponents';
import { getSlaveId } from '../Statistics/statisticsHelpers';
import { withRouter } from 'react-router-dom';

class Hold2BalanceOrder extends Component {
  static propTypes = {
    disabled: bool,
  };
  state = {
    loading: false,
    disabled: false,
  };

  isMaster = () => {
    const {
      profile: {
        master: { master },
      },
    } = this.props;
    return master && master.hash !== null && window.location.pathname.indexOf('tools/master') >= 0;
  };

  handlePaymentOrder = () => {
    const { showAlert, intl, history } = this.props;
    this.setState(() => ({ loading: true, disabled: true }));
    const master = this.isMaster();
    const req = !master ? finances.instantPaymentOrder : slaves.instantSlavePaymentOrder;

    let params = {};
    if (master) {
      params.id = getSlaveId();
    }

    req(params)
      .then(() => {
        this.setState(() => ({ loading: false, disabled: false }));
        showAlert({
          alertType: 'success',
          message: iFMessage({ intl, id: 'hold2balance-order.success' }),
          dismissable: true,
          closeInSeconds: 3,
        });
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          if (response.data.error.message.type !== 'api.finances.no_hold_to_balance') {
            const { message: error } = response.data.error;
            showAlert({
              alertType: 'danger',
              message: error.message,
              dismissable: true,
              closeInSeconds: 5,
            });
          } else {
            history.push(`/tickets/create?theme=earlyPayRequest`);
          }
        }
        this.setState({ loading: false, disabled: false });
      });
  };

  render() {
    const { disabled } = this.state;
    const { profile, hold2BalanceOrderDisable, size } = this.props;
    const isUserBlocked = profile && profile.banned;
    const isUserQuar = profile && profile.quar; // если юзер на карантине
    if (profile.isSlave) {
      return null;
    }
    return (
      <Button
        className="hold2balance form-group-btn btn-sm"
        type="button"
        size={size ? size : 'md'}
        color="primary"
        outline={this.props.theme === 3}
        onClick={this.handlePaymentOrder}
        disabled={disabled || isUserBlocked || isUserQuar || hold2BalanceOrderDisable}
      >
        <FMessage id="hold2balance-order.btn" />
      </Button>
    );
  }
}

const mapStateToProps = ({ webmaster }) => ({
  profile: webmaster.profile,
});

export default connect(mapStateToProps)(injectIntl(withRouter(Hold2BalanceOrder)));
